import { StyleSheet } from 'aphrodite';
import { brandPrimary } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '60px 20px',
		textAlign: 'center',
	},

	spinner: {
		width: '50px',
		height: '50px',
		border: `4px solid #f3f3f3`,
		borderTop: `4px solid ${brandPrimary}`,
		borderRadius: '50%',
		animation: 'spin 1s linear infinite',
		marginBottom: '20px',
	},

	message: {
		fontSize: '18px',
		color: '#666',
		margin: 0,
		fontWeight: 500,
		'@media (max-width: 480px)': {
			fontSize: '16px',
		},
	},

	// CSS animation for spinner
	'@keyframes spin': {
		'0%': { transform: 'rotate(0deg)' },
		'100%': { transform: 'rotate(360deg)' },
	},
});
